import React, {useState} from 'react';
import SqftStore from "../../../canvas/store/sqftStore";

const LightIntensitySlider = ({ initialValue, minValue, maxValue }) => {
  const [intensity, setIntensity] = useState(initialValue);

  const handleChange = (e) => {
    const newIntensity = Number(e.target.value);
    console.log("Intensity", newIntensity);
    setIntensity(newIntensity);
    SqftStore.viewGL.updateLightIntensity(newIntensity);
  };

  return (
    <input
      type="range"
      min={minValue}
      max={maxValue}
      value={intensity}
      onChange={handleChange}
      className="intensitySlider"
    />
  );
};

export default LightIntensitySlider;
